import { z } from "zod";
import { BaseResponseSchema } from "../../base/response/BaseResponseSchema";
import { DataSchema, RoomSchema } from "../../room-type/response/ShowRoomResponse";
import { PropertySchema } from "../../properties/response/ShowPropertiesResponse";
import { BookingSchema } from "../../booking/response/ShowBookingResponse";

const HousekeepingResponse = z.object({
    id: z.string(),
    property: PropertySchema.optional(),
    property_id: z.string(),
    room: RoomSchema.optional(),
    room_type_id: z.string(),
    room_type: DataSchema.optional(),
    room_id: z.string(),
    user_id: z.nullable(z.string()).optional(),
    date_housekeeping: z.string(),
    room_condition: z.string(),
    comment: z.nullable(z.string()).optional(),
    created_at: z.string(),
    updated_at: z.string(),
    booking_room: z.nullable(BookingSchema).optional(),
});

export const HousekeepingResponseSchema = BaseResponseSchema(z.array(HousekeepingResponse));
export type HousekeepingResponseSchemaType = z.infer<typeof HousekeepingResponseSchema>;
export type HousekeepingResponseType = z.infer<typeof HousekeepingResponse>;
export { HousekeepingResponse };
export const SingleHousekeepingResponseSchema = BaseResponseSchema(HousekeepingResponse);